import React from "react";

import { Controller } from "react-hook-form";
import ReactInputMask from "react-input-mask";

const ControlledInputMask = ({ label, mask, type, placeholder, name, error, control }) => {
  const isError = error ? "input-wrapper-error" : "";

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange, ...rest } }) => {
        // sending integer instead of string.
        return (
          <ReactInputMask mask={mask} value={value || ""} {...rest}>
            {inputProps => {
              return (
                <div className={`input-wrapper ${isError}`}>
                  <label className="input-label">{label}</label>
                  <input {...inputProps} onChange={onChange} className="input" type={type} placeholder={placeholder} />
                  {error && <div className="mt-5 text-error">{error.message}</div>}
                </div>
              );
            }}
          </ReactInputMask>
        );
      }}
    />
  );
}

export default ControlledInputMask;